import ExamCliniqueModal from '@/views/consultations/en-cours/examen-clinique-modal';
import api from '@/api/_cca-mobile';
import $ from 'jquery';

export default {
    name: 'examen-clinique',
    components: {
        ExamCliniqueModal
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object
    },
    data() {
        return {
            imc: '',
            consultationLatest: '',
            examCliniqueSavePending: false,

            constantes: {
                temperature: '',
                tension_arterielle: '',
                poids: '',
                poids_unit: 'g',
                taille: '',
                taille_unit: 'm',
                pouls: '',
                bras_gauche_ta: '',
                bras_gauche_unit: 'cmHg',
                bras_droit_ta:'',
                bras_droit_unit: 'cmHg',
                etat_id: '',
                organe: [],
                v_model_o: [],
            },

            exam_clinique_loading: true,
            exam_clinique_empty: false,

            // -----------------
            additional_loading: true,
            additional_empty: false,

            filtered_occurence: [],
            // v_model_o: [],
            o_occurence: [],
            selected_champ: [],
            btn_disable: false,
            save_loading: false,
            has_content: false,

            appareil_a_examiner: {},
            group_id: 0,

            to_be_deleted: {},
            toggle_modal_examination: true,
            info_user: {},

            selectedExamenClinique: undefined,
            isSharingExamenClinique: false,
        }
    },

    watch: {
        evolution_toggler() {
            this.refreshListeAppareilExamine()
            this.userInfoSetter()
        }
    },

    computed: {
        champs_exm_clinique() {
            return this.$store.getters["champs_exm_clinique"];
        },

        consultation_examen_cliniques() {
            return this.$store.getters["consultation_examen_cliniques"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        },
    },

    async mounted() {
        this.userInfoSetter()
        this.refreshListeAppareilExamine()
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        refreshListeAppareilExamine() {
            this.exam_clinique_loading = true
            let data = {
                consultation_id: this.consultation.id,
                evolution_id: this.consultation.complement && Number(this.consultation.is_end) === 1
                    ? this.evolution_id : this.evolution_id_initiale,
                est_encours: true
            }

            return this.$store.dispatch("getListeConsultationExamenClinique", data).then(() => {
                if (this.consultation_examen_cliniques.length > 0) {
                    this.exam_clinique_empty = false
                } else {
                    this.exam_clinique_empty = true
                }

            }).catch(() => {
                this.exam_clinique_empty = true
            }).finally(() => {
                this.exam_clinique_loading = false
            })
        },

        addToListExamen(group_id) {
            this.group_id = group_id
        },

        setAppareilToExamine(v, group_id) {
            this.toggle_modal_examination = (this.toggle_modal_examination)?false:true
            
            this.appareil_a_examiner = {
                consultation_appareil_id: v.consultation_appareil_id,
                group_id: group_id,
                appareil_id: v.appareil_id,
                appareil: v.libelle,
                observations: v.observations
            }
        },

        setToDeleteObservation(type_appareil_id, obs, group_id) {
            this.to_be_deleted = {
                group_id: group_id,
                type_appareil_id: type_appareil_id,
                id: obs.id,
                libelle: obs.observation
            }
        },

        removeAppareil(appareil_to_delete, group_id) {
            this.to_be_deleted = {
                consultation_id: this.consultation.id,
                group_id: group_id,
                evolution_id: this.evolution_id,
                id: appareil_to_delete.consultation_appareil_id,
                libelle: appareil_to_delete.libelle
            }
        },

        removeGroupAppareil(group_appareil) {
            this.to_be_deleted = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                group_id: group_appareil.examen_group_id,
                libelle: group_appareil.reference
            }
        },

        async handleConfirmSharing() {
            this.isSharingExamenClinique = true;
            try {
                const response = await api.shareExamenClinique(this.selectedExamenClinique.reference);

                if (response && response.status === 200) {
                    this.successToast("Examens(s) clinique(s) partagé(s) avec succès")
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 400 || error.response.status === 422) {
                        this.errorToast("Erreur de requête", 'error')
                    } else if (error.response.status === 500) {
                        this.errorToast("Une erreur s'est produitre, veuillez réessayer plustard", 'error')
                    }
                }
            } finally {
                this.isSharingExamenClinique = false;

                $('.modal').modal('hide');
            }
        }
    }
}
